import { defineStore } from 'pinia';

export const useContentStore = defineStore({
  id: 'content_store',
  state: () => ({
    contents: [],
  }),
});
